import { AnalyticsEvent } from './BaseAnalyticsEvent';
import { type AnalyticsEventName } from './types/AnalyticsEventName';

export class VideoEvent extends AnalyticsEvent<AnalyticsEventName.VIDEO_VIEW> {
  constructor(public data: { url: string; title: string }) {
    super('analytics.video_view');
  }
}
